import Accordion from "@/components/Accordion";
import { LanguageConfigModel, StyleConfigModel } from "@/pages/Messaging/types";
import React from "react";
import LogoUpload from "../../LogoUpload";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
  setStagedGraphicFile: (file: File | null) => void;
}

export function InQueueStatus(props: Props) {
  const workingStyleConfig = props.workingChatWindow.styleConfig || {};
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateStyleConfig = (updates: Partial<StyleConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      styleConfig: {
        ...workingStyleConfig,
        ...updates
      }
    });
  };
  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item
      eventKey="in-queue-status"
      onExpanded={() => props.onExpanded()}
    >
      <Accordion.Header>
        <Accordion.Title>In Queue Status</Accordion.Title>
        <Accordion.SubTitle>
          Set the appearance and behavior when users are waiting in queue.
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div>
          <LogoUpload
            setStageLogoFile={props.setStagedGraphicFile}
            update={updateStyleConfig}
            workingStyleConfig={workingStyleConfig}
            field="queueGraphicUrl"
            label="Graphic"
          />
          <div className="text-sm font-medium my-2">In Queue Title</div>
          <TextInput
            value={workingLanguageConfig.connectingMessage}
            setValue={(value) =>
              updateLanguageConfig({ connectingMessage: value })
            }
            showEmojiButton={false}
            maxWordCount={30}
          />
          <div className="text-sm font-medium mb-2">In Queue Message</div>
          <TextInput
            value={workingLanguageConfig.connectingSubmessage}
            setValue={(value) =>
              updateLanguageConfig({ connectingSubmessage: value })
            }
            showEmojiButton={false}
            maxWordCount={125}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
